import styled from "styled-components";


export const SubHeadline = styled.h3`
  font-weight: 500;
	font-size: 1.5rem;
	margin:0;
	color: ${(props) => props.theme.base['2']};
`